import { AHText, Box, useScaleFactor, useTheme } from "arkh";
import React, { useCallback, useMemo, memo } from "react";
import { StyleSheet, View } from "react-native";

import { Entypo } from "@expo/vector-icons";
import { MovingHorizontalContainer } from "../../MovingHorizontalContainer";

function GoalDisplayC(props: { mode: "GT" | "LT"; children: string }) {
  const theme = useTheme();
  const sf = useScaleFactor();
  const iconSize = useMemo(() => Math.floor(sf * 14), [sf]);
  const iconHeight = useMemo(() => Math.floor(10 * sf), [sf]);
  return (
    <Box
      spaceRight="xsmall"
      style={{
        alignItems: "center",
        width: Math.floor(32 * sf),
      }}
    >
      <Entypo
        size={iconSize}
        style={{ height: iconHeight }}
        color={props.mode === "GT" ? theme.positive : theme.negative}
        name="chevron-up"
      />
      <Box style={{ height: Math.floor(17 * sf), justifyContent: "center" }}>
        <AHText
          style={{
            zIndex: 144,
            textAlign: "center",
          }}
          minimumFontScale={0.5}
          adjustsFontSizeToFit
          numberOfLines={1}
          size={6 + Math.floor(13 / props.children.length)}
          type="subtitle"
        >
          {props.children}
        </AHText>
      </Box>
      <Entypo
        style={{
          height: iconHeight,
          transform: [{ rotateX: "190deg" }],
        }}
        size={iconSize}
        color={props.mode === "GT" ? theme.negative : theme.positive}
        name="chevron-up"
      />
    </Box>
  );
}
const GoalDisplay = React.memo(GoalDisplayC);

const GoalHorizontalBarC = (props: {
  totalHeight: number;
  maxVal: number;
  animated?: boolean;
  bars: { value: number; label?: string | undefined; mode: "GT" | "LT" }[];
}) => {
  const sf = useScaleFactor();
  const heightOfBar = useCallback(
    (val: number) => {
      if (props.maxVal === null || props.maxVal === undefined) {
        return 0;
      }
      if (val === null || val === undefined) {
        return 0;
      }
      const ret = Math.max(1, (val / props.maxVal) * props.totalHeight);
      if (Number.isNaN(ret)) {
        return 0;
      }
      return ret;
    },
    [props.maxVal, props.totalHeight]
  );

  return (
    <View
      style={{
        ...StyleSheet.absoluteFillObject,
      }}
    >
      <View
        style={{
          position: "relative",
          flex: 1,
          marginBottom: sf * 20,
        }}
      >
        {props.bars.map((bar, i) => (
          <MovingHorizontalContainer
            animated={props.animated}
            key={i}
            bottom={heightOfBar(bar.value)}
          >
            {bar.label ? (
              <GoalDisplay mode={bar.mode}>{bar.label}</GoalDisplay>
            ) : null}
            <Box
              cornerRadius="large"
              style={{ height: 1, flex: 1 }}
              color="negative"
            />
          </MovingHorizontalContainer>
        ))}
      </View>
    </View>
  );
};

export const GoalHorizontalBar = memo(GoalHorizontalBarC);
